import moment from 'moment';

export function epochToDateStr (timestamp) {
	if (!timestamp) { return }
	let date = new Date(timestamp * 1000);
	return date.toLocaleDateString();
}

export function epochToDateStrFull (timestamp) {
	if (!timestamp) { return }
	return moment(timestamp * 1000).format('MMMM Do, YYYY');
}


export function checkValue(str, max) {
	if (str.charAt(0) !== '0' || str == '00') {
		let num = parseInt(str);
		if (isNaN(num) || num <= 0 || num > max) num = 1;
		str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
	}
	return str;
}

export function getAge(birthday) {
	const {
			month, day, year,
		} = birthday,
		dob = moment().year(year).month(month).date(day),
		now = moment(),
		age = Math.floor(Math.abs(moment.duration(dob.diff(now)).asYears()));
	return age
}

export function formatTimestamp(timestamp, format = 'MM/DD/YYYY') {
	return moment(timestamp * 1000).format(format);
}
